import { Application } from "types/Dashboard";

const lower = (value: string) => value.toLowerCase();

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/**
 * Finds the application for platform and application, ignoring case.
 * Accepts the untyped response; anything that is not the applications body
 * (`{ applications: { [platform]: Application[] } | null }`) gives undefined.
 */
export const findApplication = (
  response: unknown,
  platform: string,
  application: string
): Application | undefined => {
  if (!isObject(response) || !isObject(response.applications)) {
    return undefined;
  }
  const { applications } = response;
  const platformKey = Object.keys(applications).find(
    (key) => lower(key) === lower(platform)
  );
  if (platformKey === undefined) {
    return undefined;
  }
  const entries = applications[platformKey];
  if (!Array.isArray(entries)) {
    return undefined;
  }
  return entries.find(
    (entry) =>
      isObject(entry) &&
      typeof entry.id === "string" &&
      lower(entry.id) === lower(application)
  ) as Application | undefined;
};

/** The url is usable only when it is a non-empty string. */
export const getUsableUrl = (app: Application | undefined): string | null =>
  app && typeof app.url === "string" && app.url !== "" ? app.url : null;

/** Same rule as the dashboard's getRedirectUrl: no encoding, no fragment handling. */
export const buildRedirectUrl = (url: string, partnerId: string): string =>
  url.includes("?")
    ? `${url}&partnerId=${partnerId}`
    : `${url}?partnerId=${partnerId}`;
